import { Action } from 'redux';
import { put } from 'redux-saga/effects';
import { removeBasketSaga } from './removeBasket';
import { ErrorAction } from './../../root.types';
import { BasketActionTypes, BasketActions } from '../basket.types';
import { ACTION_CREATOR_NAME, userHelper, errorToBasketErrorModel } from 'helpers';
import { BasketSagaReturnType, callBasketSaga } from 'store/sagaHelpers';

export interface RemoveUserInfoAction extends Action<BasketActionTypes.REMOVE_USER_INFO>{
}

export interface RemoveUserInfoActionStart extends Action<BasketActionTypes.REMOVE_USER_INFO_START> {
}

export interface RemoveUserInfoActionSuccess extends Action<BasketActionTypes.REMOVE_USER_INFO_SUCCESS> {
}

export interface RemoveUserInfoActionError extends ErrorAction<BasketActionTypes.REMOVE_USER_INFO_ERROR> {
}

export const removeUserInfo: () => RemoveUserInfoAction = () => ({
    type: BasketActionTypes.REMOVE_USER_INFO
});
removeUserInfo[ACTION_CREATOR_NAME] = 'removeUserInfo';

export type RemoveUserInfoFunc = (...args: Parameters<typeof removeUserInfo>) => void;

export function* removeUserInfoSaga(): BasketSagaReturnType {
    yield put<BasketActions>({
        type: BasketActionTypes.REMOVE_USER_INFO_START
    });

    try {
        userHelper.clearUserSession();
        yield callBasketSaga(removeBasketSaga);

        yield put<BasketActions>({
            type: BasketActionTypes.REMOVE_USER_INFO_SUCCESS
        });

        return true;
    } catch (error) {
        yield put<BasketActions>({
            type: BasketActionTypes.REMOVE_USER_INFO_ERROR,
            error: errorToBasketErrorModel(error, 'removeUserInfoSaga')
        });

        return false;
    }
}